<template>
  <card class="row centralize">
    <div>
      <label> {{ searchTxt }} </label>
      <fg-input
                :placeholder="searchTxt"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split">
      </fg-input>
    </div>
    <billing-collapse-item
      v-for="(data, index) in queriedData"
      :key="index"
      :data="data"
    ></billing-collapse-item>
  </card>
</template>
<script>
import {Collapse, CollapseItem} from "@/components/UIComponents";
import BillingCollapseItem from "@/components/Dashboard/Views/Dashboard/Billing/billing-collapse-item.vue";

export default {
  name: "BillingWalletMobileView",
  components: {
    BillingCollapseItem,
    Collapse,
    CollapseItem
  },
  props: {
    tableData: [],
  },
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to)
    },
    queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let searchRegex = new RegExp(this.escapeRegExp(this.searchQuery), 'gi');
              if (row[key] !== null && row[key].toString().match(searchRegex) !== null) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        result.sort((a, b) => {
          if (a.affiliateUser < b.affiliateUser) return -1
          if (a.affiliateUser > b.affiliateUser) return 1
          return 0
        })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
  },
  data() {
    return {
      searchTxt: this.$t('searchtxt'),
      isOpen: false,
      searchQuery: '',
      propsToSearch: ['userid', 'fullname', 'affiliateUser'],
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50],
        total: 0
      },
    }
  },
  methods: {
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  }
}
</script>

<style scoped>
.centralize {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
